/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TilingConfigOutput } from '../models/TilingConfigOutput';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class TilingConfigOutputService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get tiling configuration by type
     * Retrieves a TilingConfigOutput resource.
     * @param type Tiling config type (e.g., map)
     * @returns TilingConfigOutput TilingConfigOutput resource
     * @throws ApiError
     */
    public apiTilingConfigTypeGet(type: string): CancelablePromise<TilingConfigOutput> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/tiling-config/{type}',
            path: {
                type: type,
            },
            errors: {
                400: `Bad request`,
                404: `Not found`,
                500: `Internal server error`,
            },
        });
    }
}
